module.exports = __webpack_public_path__ + "img/low_car.df8577da.svg";